import { CardType, CardVisualType } from '@/types/Card';
import { AgentEnriched } from '@/types/agent';
import { ActionablesInfo } from '@/types/actionalbles';
import { CashAccountEnriched } from '@/types/cashAccount';
import { Action, Link, WithRequired, YapMoney } from '@/types/general';

export enum CardProgramURI {
  Base = '/card-programs',
  BaseV2 = '/v2/card-programs',

  Cards = '/cards',
  BulkAddCard = '/extend-bulk',
  AddCard = '/extend'
}
export enum CardProgramContractsURI {
  Base = '/card-program-contracts',
  BaseV2 = '/v2/card-program-contracts',

  ChangeAdmins = '/change-admins'
}

export enum CardProgramStatus {
  New = 'new',
  Active = 'active',
  Cancelling = 'cancelling',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Offered = 'offered',
  Retired = 'retired',
  Signed = 'signed'
}

export const cardProgramSortOrder = [
  CardProgramStatus.New,
  CardProgramStatus.Active,
  CardProgramStatus.Cancelling,
  CardProgramStatus.Cancelled
];

interface CardPgmAccount {
  accountEnriched: CashAccountEnriched;
  accountUid: string;
}

interface CardPgmAdmin {
  actionable?: boolean;
  agentEnriched?: AgentEnriched;
  agentUid: string;
  empowerment?: 'as_one' | 'as_three' | 'as_two' | 'none';
}
interface CardProgramContractInfo {
  allowedDebitAccounts: CardPgmAccount[];
  cardProgramAdmins: CardPgmAdmin[];
  cardProgramContractStatus: CardProgramStatus;
  cardProgramContractUid: string;
  conflictOfInterestFlag: boolean;
  maxCardLimit: YapMoney;
  productOrderUid: string;
}

interface NumInState {
  count: number;
  entityStatus: string;
}

interface CardPgmAccount {
  accountEnriched: CashAccountEnriched;
  accountUid: string;
}

interface CardProgramInfo {
  allowedDebitAccounts: CardPgmAccount[];
  allowedProductTypes: Array<'combo' | 'virtual'>;
  allowedProductVisuals: Array<CardVisualType>;
  cardProgramContractUid: string;
  cardProgramCreationDate: string;
  cardProgramStatus: CardProgramStatus;
  cardProgramUid: string;
  companyAddressAsDefault: boolean;
  defaultATMDailyLimit: YapMoney;
  defaultATMMonthlyLimit: YapMoney;
  defaultCardLimit: YapMoney;
  partnershipEnriched: AgentEnriched;
  partnershipUid: string;
  programName: string;
  secondCardLine: string;
}

export interface CardProgramRsp {
  actionables: ActionablesInfo;
  contract: CardProgramContractInfo;
  isActionable: boolean;

  numCards?: NumInState[];
  numExtOrders?: NumInState[];
  program: CardProgramInfo;
}

export function getCardTypeLabels(allowedProductTypes: string[]): string[] {
  const labelMap: Record<string, string> = {
    combo: 'webapp.partnership.cardType.combo',
    virtual: 'webapp.partnership.cardType.virtual'
  };

  return allowedProductTypes.map((type) => labelMap[type]);
}

/**
 * @deprecated Use CardProgramRsp instead
 */
export interface CardProgram {
  accounts: Array<{
    accountUid: string;
    accountEnriched: {
      accountCcy: string;
      accountName: string;
      bban: string;
      iban: string;
      uid: string;
    };
  }>;
  name: string;
  status: CardProgramStatus;
  defaultMonthlyLimit?: number;
  defaultDailyAtmLimit?: number;
  defaultShippingAddressType?: string;
  embossLine2?: string;
  allowedCardTypes?: Array<CardType>;
  _links: {
    self: Link;
    admins: Link & { embedded: Array<{ name: string; naturalPerson_uri: string; myPicture_uri: string }> };
    cards: WithRequired<Link, 'count'> & { active: number; frozen: number; locked: number };
    contract: Link;
    orders: Link & { open: number };
    partnership?: Link & { name: string };
  };
  _actions: {
    addCard?: Action;
    bulkAddCard?: Action;
    edit?: Action;
    editAdmins?: Action;
    delete?: Action;
  };
}
